import React from 'react';
import TabBar from "../../TabBar";
import { SwitchInput } from "../../Form";
import { inject, observer } from "mobx-react/index";

@inject('ticketStore')
@observer
class TicketHome extends React.Component {

  onChangeSwitch = (key) => {
    const { ticketStore } = this.props;
    ticketStore.onChangeViewSwitch(key);
    ticketStore.selectedMarker = null;
  };

  render() {
    const { assigned_to_all, view_archived } = this.props.ticketStore;

    return (
      <div>
        <div className='inline-grid space-between'>
          <TabBar
            items={[
              { to: '/monitoring/ticket/tabular', label: 'Tabular' },
              { to: '/monitoring/ticket/map', label: 'Map' },
              // { to: '/monitoring/ticket/archived', label: 'Archived' },
            ]}
          />
          <div className='inline-grid'>
            <SwitchInput label='Assigned to all' value={assigned_to_all} onChange={() => this.onChangeSwitch('assigned_to_all')} />
            <SwitchInput label='View Archived' value={view_archived} onChange={() => this.onChangeSwitch('view_archived')} />
          </div>
        </div><br/>
        {this.props.children}
      </div>
    );
  }
}

export default TicketHome;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketHome.js